// Modo Atividades — Aventuras da Lulu e do Nando (Fase A + B)
// Mapa de mundos → trilha de fases → jogos (flashcards ▸ memória ▸ completar ▸ quiz)
// → estrelas. Gamificação: sequência de dias, moedas, álbum de figurinhas e
// missões de conversa (a ponte com o chat). Conteúdo do backend + reserva local.
import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { CoreContext } from 'context/CoreContext';
import ContainerAuthenticated from 'containers/Authenticated';
import {
  getMundos, getPalavras, carregarProgresso, salvarEstrelas, tocarAudio, PALAVRAS_POR_FASE,
  carregarPerfilGamer, registrarDiaJogado, ganharMoedas, ganharFigurinha, getAlbuns,
  abrirPacote, CUSTO_PACOTE, getMissoes, missoesDoNivel, pedirReabastecimento,
  getIdiomaAtiv, setIdiomaAtiv, normalizarIdioma, aplicarIdioma,
  tocarVoz, getMetaHoje, registrarFaseNaMeta, META_FASES_DIA,
} from 'services/atividades';
import { getIdiomaAlvo, getNivel } from 'services/chatV4';
import {
  Wrap, Titulo, Subtitulo, Grade, CartaoMundo, SeloMundo, SeloPequeno, VersoCarta,
  NomeMundo, InfoMundo, LinhaFases, BotaoFase, BotaoVoltar, CartaoJogo, ImagemFlash,
  PalavraGrande, Traducao, BotaoSom, BotaoPrincipal, GradeMemoria, CartaMemoria,
  GradeQuiz, OpcaoQuiz, EstrelasGrandes, BarraProgresso,
  BarraTopo, Selo, BotaoTopo, GradeAlbum, SlotFigurinha, NomeFigurinha, DicaFigurinha,
  CartaoMissao, MissaoTexto, MissaoRecompensa, LetrasAlvo, CaixaLetra, LetrasOpcoes,
  TeclaLetra, Confete, Fundo, PopFigurinha,
} from './styled';

const NOME_GUIA = { lulu: 'Lulu', nando: 'Nando' };
const TOTAL_FASES = 3;
const ROTA_CHAT = { 'lulu-idiomas': '/dashboard/chatbox03', 'nando-idiomas': '/dashboard/chatbox',
  'lulu-biblico': '/dashboard/chatbox07', 'nando-biblico': '/dashboard/chatbox05' };

const embaralhar = (lista) => {
  const c = [...lista];
  for (let i = c.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [c[i], c[j]] = [c[j], c[i]]; }
  return c;
};
const estrelasDaFase = (erros) => (erros === 0 ? 3 : erros <= 2 ? 2 : 1);
const desenhaEstrelas = (n) => '⭐'.repeat(n) + '☆'.repeat(Math.max(0, 3 - n));
const letraAleatoria = (menos) => {
  const abc = 'abcdefghijklmnopqrstuvwxyz'.split('').filter((l) => !menos.includes(l));
  return abc[Math.floor(Math.random() * abc.length)];
};

export default function DashboardAtividades() {
  const { currentProfile, user } = useContext(CoreContext);
  const history = useHistory();
  const dono = currentProfile?.id || user?.id;

  const [mundos, setMundos] = useState([]);
  const [progresso, setProgresso] = useState({});
  const [gamer, setGamer] = useState(null);
  const [albuns, setAlbuns] = useState([]);
  const [albumSel, setAlbumSel] = useState(1);
  const [missoes, setMissoes] = useState([]);
  const [tela, setTela] = useState({ view: 'mapa' });
  // Idioma das Atividades: começa no que a criança escolheu (Atividades > chat); '' = ainda não escolheu
  const [idioma, setIdioma] = useState(() => getIdiomaAtiv(dono) || normalizarIdioma(getIdiomaAlvo(dono)) || '');
  const [metaHoje, setMetaHoje] = useState(() => getMetaHoje(dono));
  const [figurinhaNova, setFigurinhaNova] = useState(null);
  const [festa, setFesta] = useState(false);
  const [aviso, setAviso] = useState('');

  useEffect(() => {
    const iniciar = async () => {
      const [ms, pr, alb, mis] = await Promise.all([
        getMundos(), carregarProgresso(currentProfile?.id, dono), getAlbuns(), getMissoes(),
      ]);
      setMundos(ms); setProgresso(pr); setAlbuns(alb); setMissoes(mis);
      const album1 = alb.find((a) => a.numero === 1) || { figurinhas: [] };
      let g = await carregarPerfilGamer(currentProfile?.id, dono);
      g = registrarDiaJogado(currentProfile?.id, dono, g); // conta o dia de hoje
      // conquistas de boas-vindas e sequência (todas do Álbum 1)
      const marcos = [['lulu_oi', true], ['nando_foguete', (g.dias_seguidos || 0) >= 3], ['lulu_campea', (g.dias_seguidos || 0) >= 7]];
      for (const [id, cond] of marcos) {
        if (cond) {
          const r = ganharFigurinha(currentProfile?.id, dono, g, id, album1);
          g = r.estado;
          if (r.nova) { setFigurinhaNova(id); soltarFesta(); }
        }
      }
      // garante a figurinha rara de cada álbum já concluído (ex.: última veio de missão)
      for (const a of alb) {
        const naoRaras = a.figurinhas.filter((f) => f.origem !== 'rara').map((f) => f.id);
        const raras = a.figurinhas.filter((f) => f.origem === 'rara');
        for (const rara of raras) {
          if (naoRaras.length > 0 && naoRaras.every((x) => (g.figurinhas || []).includes(x)) && !(g.figurinhas || []).includes(rara.id)) {
            const r = ganharFigurinha(currentProfile?.id, dono, g, rara.id, a);
            g = r.estado;
            if (r.nova) { setFigurinhaNova(rara.id); soltarFesta(); }
          }
        }
      }
      setGamer(g);
    };
    iniciar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentProfile?.id]);

  // Auto-reabastecimento: ao abrir as Missões, se as missões de IDIOMAS do nível
  // da criança estão acabando (≤ 8 por fazer), avisa o backend para gerar mais
  // (que entram inativas, aguardando aprovação). Invisível para a criança.
  useEffect(() => {
    if (tela.view !== 'missoes' || !missoes.length || !idioma) return;
    const visiveis = missoesDoNivel(missoes, { lulu: getNivel(dono, 'lulu'), nando: getNivel(dono, 'nando') }, idioma);
    const feitas = gamer?.missoes_feitas || [];
    const restantesIdiomas = visiveis.filter((m) => m.modo === 'idiomas' && !feitas.includes(m.id)).length;
    if (restantesIdiomas <= 8) pedirReabastecimento(idioma);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela.view, missoes, idioma]);

  // Descobre a qual álbum uma figurinha pertence (para a lógica da rara)
  const albumDe = (id) => albuns.find((a) => a.figurinhas.some((f) => f.id === id)) || albuns.find((a) => a.numero === 1);

  // Concede uma figurinha (mostra pop-up se for nova)
  const concede = (id, gAtual) => {
    const base = gAtual || gamer;
    if (!base) return base;
    const { estado, nova } = ganharFigurinha(currentProfile?.id, dono, base, id, albumDe(id));
    setGamer(estado);
    if (nova) { setFigurinhaNova(id); soltarFesta(); }
    return estado;
  };

  const soltarFesta = () => { setFesta(true); setTimeout(() => setFesta(false), 2600); };

  const estrelasDe = (slug, fase) => progresso[`${slug}:${fase}`] || 0;
  const mundoCompleto = (slug) => [1, 2, 3].every((f) => estrelasDe(slug, f) > 0);

  const escolherIdioma = (v) => { setIdioma(v); setIdiomaAtiv(dono, v); };

  const abrirMundo = async (mundo) => {
    const palavras = aplicarIdioma(await getPalavras(mundo.slug), idioma || 'ingles');
    setTela({ view: 'trilha', mundo, palavras });
  };
  const jogarFase = (mundo, palavras, fase) => {
    const doJogo = palavras.slice((fase - 1) * PALAVRAS_POR_FASE, fase * PALAVRAS_POR_FASE);
    setTela({ view: 'jogo', mundo, palavras, fase, doJogo });
  };

  const terminarFase = (erros) => {
    const { mundo, fase } = tela;
    const estrelas = estrelasDaFase(erros);
    const primeiraVez = Object.keys(progresso).length === 0;
    const novoProg = salvarEstrelas(currentProfile?.id, dono, mundo.slug, fase, estrelas);
    setProgresso({ ...novoProg });

    // Moedas: 10 por estrela
    let g = ganharMoedas(currentProfile?.id, dono, gamer, estrelas * 10);
    setGamer(g);

    // Conquistas
    if (primeiraVez) g = concede('nando_joia', g);
    if (estrelas === 3) g = concede('lulu_estrela', g);
    const completou = [1, 2, 3].every((f) => (novoProg[`${mundo.slug}:${f}`] || 0) > 0);
    if (completou) g = concede('nando_trofeu', g);
    const doisMundos = mundos.length >= 2 && mundos.every((m) => [1, 2, 3].every((f) => (novoProg[`${m.slug}:${f}`] || 0) > 0));
    if (doisMundos) g = concede('lulu_medalha', g);
    if ((g.moedas || 0) >= 100) g = concede('nando_musica', g);
    if ((g.moedas || 0) >= 300) g = concede('nando_estrela', g);

    // Meta diária: registra a fase e celebra com a voz do mascote
    const fasesHoje = registrarFaseNaMeta(dono);
    setMetaHoje(fasesHoje);
    if (fasesHoje === META_FASES_DIA) {
      tocarVoz(mundo.personagem, 'meta'); // "Você cumpriu a meta de hoje!"
    } else {
      tocarVoz(mundo.personagem, 'parabens');
    }

    soltarFesta();
    setTela({ view: 'fim', mundo, palavras: tela.palavras, fase, estrelas, metaAgora: fasesHoje === META_FASES_DIA });
  };

  const irParaMissao = (m) => {
    localStorage.setItem('jk_missao_ativa', JSON.stringify(m));
    history.push(ROTA_CHAT[`${m.personagem}-${m.modo}`] || '/dashboard/chatbox03');
  };

  const abrirPacoteAgora = () => {
    const r = abrirPacote(albumAtual, currentProfile?.id, dono, gamer);
    if (r.erro === 'moedas') {
      setAviso(`Você precisa de ${CUSTO_PACOTE} moedas para abrir um pacote! Jogue mais para ganhar. 🪙`);
      return;
    }
    if (r.erro === 'completo') {
      setAviso('Uau! Você já tem TODAS as figurinhas de pacote deste álbum! 🎉');
      return;
    }
    setAviso('');
    setGamer(r.estado);
    setFigurinhaNova(r.ganhou);
    soltarFesta();
  };

  // Helpers de álbuns/figurinhas (juntando Álbum 1 + álbuns do backend)
  const todasFig = albuns.flatMap((a) => a.figurinhas);
  const figDe = (id) => todasFig.find((f) => f.id === id);
  const totalDisp = todasFig.length;
  const totalTem = (gamer?.figurinhas || []).filter((id) => todasFig.some((f) => f.id === id)).length;
  const albumAtual = albuns.find((a) => a.numero === albumSel) || albuns[0] || { figurinhas: [], nome: '' };
  const temNoAlbum = (album) => (album.figurinhas || []).filter((f) => (gamer?.figurinhas || []).includes(f.id)).length;

  return (
    <ContainerAuthenticated primary page={'atividades'}>
      {/* Confete da festa */}
      {festa && (
        <>{Array.from({ length: 26 }, (_, i) => (
          <Confete key={i} x={Math.random() * 100} tam={16 + Math.random() * 18} atraso={Math.random() * 0.6}>
            {['⭐', '🎉', '🌟', '🎊', '✨'][i % 5]}
          </Confete>
        ))}</>
      )}

      {/* Pop-up de figurinha nova */}
      {figurinhaNova && (
        <Fundo onClick={() => setFigurinhaNova(null)}>
          <PopFigurinha onClick={(e) => e.stopPropagation()}>
            <Titulo>Nova figurinha! 🎉</Titulo>
            <img src={figDe(figurinhaNova) && figDe(figurinhaNova).imagem_url} alt="" />
            <NomeMundo>{figDe(figurinhaNova) && figDe(figurinhaNova).nome}</NomeMundo>
            <BotaoPrincipal onClick={() => setFigurinhaNova(null)}>Legal! 😍</BotaoPrincipal>
          </PopFigurinha>
        </Fundo>
      )}

      <Wrap>
        {tela.view === 'mapa' && (
          <>
            <BotaoVoltar onClick={() => history.push('/dashboard')}>⬅ Modos</BotaoVoltar>
            <Titulo>🎮 Aventuras da Lulu e do Nando</Titulo>
            <BarraTopo>
              <Selo cor={metaHoje >= META_FASES_DIA ? '#aed581' : '#e0e0e0'}>
                ⭐ Meta de hoje: {metaHoje >= META_FASES_DIA ? 'cumprida! ✅' : `${metaHoje}/${META_FASES_DIA} fase`}
              </Selo>
              <Selo cor="#ff8a65">🔥 {gamer?.dias_seguidos || 0} {gamer?.dias_seguidos === 1 ? 'dia' : 'dias'}</Selo>
              <Selo cor="#ffd54f">🪙 {gamer?.moedas || 0}</Selo>
              <BotaoTopo cor="#7C5CFC" onClick={() => setTela({ view: 'album' })}>🖼️ Álbum ({totalTem}/{totalDisp})</BotaoTopo>
              <BotaoTopo cor="#26a69a" onClick={() => setTela({ view: 'missoes' })}>🎯 Missões</BotaoTopo>
            </BarraTopo>
            <BarraTopo>
              <span style={{ fontWeight: 'bold', color: 'var(--jk-text)' }}>Idioma:</span>
              <BotaoTopo cor={idioma === 'ingles' ? '#4FA3E3' : '#b7c4cc'} onClick={() => escolherIdioma('ingles')}>🇺🇸 Inglês</BotaoTopo>
              <BotaoTopo cor={idioma === 'espanhol' ? '#E36BAA' : '#b7c4cc'} onClick={() => escolherIdioma('espanhol')}>🇪🇸 Espanhol</BotaoTopo>
            </BarraTopo>
            {!idioma ? (
              <Subtitulo>👆 Escolha o idioma acima para começar a aventura!</Subtitulo>
            ) : (
              <>
                <Subtitulo>Explorando em <b>{idioma === 'espanhol' ? 'Espanhol 🇪🇸' : 'Inglês 🇺🇸'}</b> — escolha um mundo e ganhe estrelas!</Subtitulo>
                <Grade>
                  {mundos.map((m) => {
                    const total = [1, 2, 3].reduce((s, f) => s + estrelasDe(m.slug, f), 0);
                    return (
                      <CartaoMundo key={m.slug} cor={m.cor} onClick={() => abrirMundo(m)}>
                        <SeloMundo src={m.capa_url} alt={m.nome} />
                        <NomeMundo>{m.nome}{mundoCompleto(m.slug) ? ' 🏆' : ''}</NomeMundo>
                        <InfoMundo>com {NOME_GUIA[m.personagem] || 'Lulu'}</InfoMundo>
                        <InfoMundo>⭐ {total} de {TOTAL_FASES * 3}</InfoMundo>
                      </CartaoMundo>
                    );
                  })}
                </Grade>
              </>
            )}
          </>
        )}

        {tela.view === 'album' && (
          <>
            <BotaoVoltar onClick={() => setTela({ view: 'mapa' })}>⬅ Voltar</BotaoVoltar>
            <Titulo>🖼️ {albumAtual.nome}</Titulo>
            {albuns.length > 1 && (
              <BarraTopo>
                {albuns.map((a) => (
                  <BotaoTopo key={a.numero} cor={a.numero === albumSel ? '#7C5CFC' : '#b0a8d8'} onClick={() => { setAlbumSel(a.numero); setAviso(''); }}>
                    Álbum {a.numero} ({temNoAlbum(a)}/{a.figurinhas.length})
                  </BotaoTopo>
                ))}
              </BarraTopo>
            )}
            <Subtitulo>
              {temNoAlbum(albumAtual) === albumAtual.figurinhas.length
                ? '🏆 Álbum completo! Parabéns, colecionador(a)!'
                : `Você tem ${temNoAlbum(albumAtual)} de ${albumAtual.figurinhas.length}! Abra pacotes para completar.`}
            </Subtitulo>
            <BarraTopo>
              <Selo cor="#ffd54f">🪙 {gamer?.moedas || 0}</Selo>
              <BotaoTopo cor="#ff7043" onClick={abrirPacoteAgora}>🎁 Abrir pacote ({CUSTO_PACOTE} 🪙)</BotaoTopo>
            </BarraTopo>
            {aviso && <Subtitulo style={{ color: '#c0392b', fontWeight: 'bold' }}>{aviso}</Subtitulo>}
            <GradeAlbum>
              {albumAtual.figurinhas.map((f) => {
                const tem = (gamer?.figurinhas || []).includes(f.id);
                return (
                  <SlotFigurinha key={f.id} tem={tem}>
                    <img src={f.imagem_url} alt={f.nome} />
                    <NomeFigurinha>{tem ? f.nome : '???'}</NomeFigurinha>
                    <DicaFigurinha>{tem ? '✅ Conquistada!' : f.dica}</DicaFigurinha>
                  </SlotFigurinha>
                );
              })}
            </GradeAlbum>
          </>
        )}

        {tela.view === 'missoes' && (
          <>
            <BotaoVoltar onClick={() => setTela({ view: 'mapa' })}>⬅ Voltar</BotaoVoltar>
            <Titulo>🎯 Missões de Conversa</Titulo>
            <Subtitulo>Missões do seu nível em <b>{idioma === 'espanhol' ? 'Espanhol 🇪🇸' : 'Inglês 🇺🇸'}</b>! Converse com a Lulu e o Nando, cumpra e ganhe moedas.</Subtitulo>
            {missoesDoNivel(missoes, { lulu: getNivel(dono, 'lulu'), nando: getNivel(dono, 'nando') }, idioma).map((m) => {
              const feita = (gamer?.missoes_feitas || []).includes(m.id);
              return (
                <CartaoMissao key={m.id} cor={m.cor} feita={feita} onClick={() => !feita && irParaMissao(m)}>
                  <SeloPequeno src={`/atividades/capas/${m.modo === 'idiomas' ? (m.personagem === 'nando' ? 'animais' : 'cores') : 'animais'}.png`} alt="" />
                  <MissaoTexto>
                    {m.titulo}
                    <MissaoRecompensa>{feita ? '✅ Cumprida!' : `🪙 +${m.moedas} moedas`}</MissaoRecompensa>
                  </MissaoTexto>
                  {!feita && <span>▶️</span>}
                </CartaoMissao>
              );
            })}
          </>
        )}

        {tela.view === 'jogo' && (
          <JogoDaFase
            mundo={tela.mundo} fase={tela.fase} palavras={tela.doJogo}
            aoSair={() => setTela({ view: 'trilha', mundo: tela.mundo, palavras: tela.palavras })}
            aoTerminar={terminarFase}
          />
        )}

        {tela.view === 'trilha' && (
          <>
            <BotaoVoltar onClick={() => setTela({ view: 'mapa' })}>⬅ Voltar ao mapa</BotaoVoltar>
            <Titulo><SeloPequeno src={tela.mundo.capa_url} alt="" />{tela.mundo.nome}</Titulo>
            <Subtitulo>Complete uma fase para abrir a próxima!</Subtitulo>
            <LinhaFases>
              {[1, 2, 3].map((fase) => {
                const bloqueada = fase > 1 && estrelasDe(tela.mundo.slug, fase - 1) === 0;
                return (
                  <BotaoFase key={fase} cor={tela.mundo.cor} bloqueada={bloqueada} disabled={bloqueada}
                    onClick={() => !bloqueada && jogarFase(tela.mundo, tela.palavras, fase)}>
                    <span>{bloqueada ? '🔒' : '▶️'} Fase {fase}</span>
                    <span>{desenhaEstrelas(estrelasDe(tela.mundo.slug, fase))}</span>
                  </BotaoFase>
                );
              })}
            </LinhaFases>
          </>
        )}

        {tela.view === 'fim' && (
          <CartaoJogo>
            <Titulo>Parabéns! 🎉</Titulo>
            <EstrelasGrandes>{desenhaEstrelas(tela.estrelas)}</EstrelasGrandes>
            <Subtitulo>Você completou a Fase {tela.fase} do {tela.mundo.nome}!</Subtitulo>
            <InfoMundo>🪙 +{tela.estrelas * 10} moedas</InfoMundo>
            {tela.metaAgora && (
              <Subtitulo style={{ color: '#2e7d32', fontWeight: 'bold' }}>⭐ Meta de hoje cumprida! Você é demais! 🎉</Subtitulo>
            )}
            {tela.fase < TOTAL_FASES ? (
              <BotaoPrincipal cor={tela.mundo.cor} onClick={() => jogarFase(tela.mundo, tela.palavras, tela.fase + 1)}>
                Próxima fase ➜
              </BotaoPrincipal>
            ) : (
              <Subtitulo>Você terminou este mundo! 🏆</Subtitulo>
            )}
            <div>
              <BotaoVoltar onClick={() => setTela({ view: 'trilha', mundo: tela.mundo, palavras: tela.palavras })}>⬅ Voltar às fases</BotaoVoltar>
            </div>
          </CartaoJogo>
        )}
      </Wrap>
    </ContainerAuthenticated>
  );
}

/* ============ O JOGO DE UMA FASE: flashcards ▸ memória ▸ completar ▸ quiz ============ */
function JogoDaFase({ mundo, fase, palavras, aoSair, aoTerminar }) {
  const [etapa, setEtapa] = useState('flash');
  const [erros, setErros] = useState(0);
  const errar = () => setErros((e) => e + 1);

  // Voz-guia: o mascote do mundo explica cada mini-jogo em voz alta
  // (essencial para crianças que ainda não leem — padrão Khan Kids/Lingokids)
  useEffect(() => { tocarVoz(mundo.personagem, etapa); }, [etapa, mundo.personagem]);

  return (
    <>
      <BotaoVoltar onClick={aoSair}>⬅ Sair da fase</BotaoVoltar>
      <Titulo><SeloPequeno src={mundo.capa_url} alt="" />Fase {fase}</Titulo>
      {etapa === 'flash' && <Flashcards mundo={mundo} palavras={palavras} aoConcluir={() => setEtapa('memoria')} />}
      {etapa === 'memoria' && <JogoMemoria mundo={mundo} palavras={palavras} registrarErro={errar} aoConcluir={() => setEtapa('completar')} />}
      {etapa === 'completar' && <CompletaPalavra mundo={mundo} palavras={palavras} registrarErro={errar} aoConcluir={() => setEtapa('quiz')} />}
      {etapa === 'quiz' && <Quiz mundo={mundo} palavras={palavras} registrarErro={errar} aoConcluir={() => aoTerminar(erros)} />}
    </>
  );
}

/* 1) Flashcards falantes */
function Flashcards({ mundo, palavras, aoConcluir }) {
  const [indice, setIndice] = useState(0);
  const p = palavras[indice];
  // 1º cartão espera a voz-guia terminar (evita duas vozes ao mesmo tempo)
  useEffect(() => {
    if (!p) return undefined;
    const t = setTimeout(() => tocarAudio(p.audio_url), indice === 0 ? 1800 : 0);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [p]);
  if (!p) return null;
  return (
    <CartaoJogo>
      <BarraProgresso>Cartão {indice + 1} de {palavras.length} — ouça e repita!</BarraProgresso>
      <ImagemFlash src={p.imagem_url} alt={p.portugues} />
      <PalavraGrande>{p.alvo}</PalavraGrande>
      <Traducao>{p.portugues}</Traducao>
      <BotaoSom cor={mundo.cor} onClick={() => tocarAudio(p.audio_url)}>🔊 Ouvir</BotaoSom>
      <div>
        <BotaoPrincipal cor={mundo.cor} onClick={() => (indice + 1 < palavras.length ? setIndice(indice + 1) : aoConcluir())}>
          {indice + 1 < palavras.length ? 'Próximo ➜' : 'Vamos jogar! 🎲'}
        </BotaoPrincipal>
      </div>
    </CartaoJogo>
  );
}

/* 2) Jogo da memória (imagem ↔ palavra) */
function JogoMemoria({ mundo, palavras, registrarErro, aoConcluir }) {
  const [cartas, setCartas] = useState([]);
  const [viradas, setViradas] = useState([]);
  const [acertadas, setAcertadas] = useState([]);
  const [travado, setTravado] = useState(false);

  useEffect(() => {
    setCartas(embaralhar([
      ...palavras.map((p) => ({ tipo: 'imagem', ingles: p.ingles, conteudo: p.imagem_url })),
      ...palavras.map((p) => ({ tipo: 'palavra', ingles: p.ingles, conteudo: p.alvo })),
    ]));
    setViradas([]); setAcertadas([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (cartas.length > 0 && acertadas.length === palavras.length) {
      const t = setTimeout(aoConcluir, 900);
      return () => clearTimeout(t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acertadas, cartas]);

  const clicar = (i) => {
    if (travado || viradas.includes(i) || acertadas.includes(cartas[i].ingles)) return;
    const agora = [...viradas, i];
    setViradas(agora);
    if (agora.length === 2) {
      const [a, b] = agora.map((x) => cartas[x]);
      if (a.ingles === b.ingles && a.tipo !== b.tipo) {
        const pal = palavras.find((p) => p.ingles === a.ingles);
        if (pal) tocarAudio(pal.audio_url);
        setAcertadas((ac) => [...ac, a.ingles]); setViradas([]);
      } else {
        registrarErro(); setTravado(true);
        setTimeout(() => { setViradas([]); setTravado(false); }, 900);
      }
    }
  };

  return (
    <CartaoJogo>
      <BarraProgresso>Jogo da memória: junte cada figura com a palavra! ({acertadas.length}/{palavras.length})</BarraProgresso>
      <GradeMemoria>
        {cartas.map((c, i) => {
          const aberta = viradas.includes(i) || acertadas.includes(c.ingles);
          return (
            <CartaMemoria key={i} cor={mundo.cor} virada={aberta} acertada={acertadas.includes(c.ingles)} onClick={() => clicar(i)}>
              {aberta ? (c.tipo === 'imagem' ? <img src={c.conteudo} alt={(palavras.find((p) => p.ingles === c.ingles) || {}).portugues || ''} /> : c.conteudo) : <VersoCarta src="/atividades/verso_carta.png" alt="Carta virada" />}
            </CartaMemoria>
          );
        })}
      </GradeMemoria>
    </CartaoJogo>
  );
}

/* 3) Complete a palavra (uma letra faltando + opções) */
function CompletaPalavra({ mundo, palavras, registrarErro, aoConcluir }) {
  const [indice, setIndice] = useState(0);
  const [puzzle, setPuzzle] = useState(null);
  const [usadas, setUsadas] = useState([]);
  const [preenchida, setPreenchida] = useState(false);
  const p = palavras[indice];

  useEffect(() => {
    if (!p) return;
    const pos = Math.floor(Math.random() * p.alvo.length);
    const correta = p.alvo[pos].toLowerCase();
    const distratoras = [letraAleatoria([correta]), letraAleatoria([correta])];
    setPuzzle({ pos, correta, opcoes: embaralhar([correta, ...distratoras]) });
    setUsadas([]); setPreenchida(false);
    // 1ª palavra espera a voz-guia terminar (evita duas vozes ao mesmo tempo)
    const t = setTimeout(() => tocarAudio(p.audio_url), indice === 0 ? 1800 : 0);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [indice, p && p.alvo]);

  if (!p || !puzzle) return null;

  const escolher = (letra) => {
    if (preenchida) return;
    if (letra === puzzle.correta) {
      setPreenchida(true);
      tocarAudio(p.audio_url);
      setTimeout(() => { indice + 1 < palavras.length ? setIndice(indice + 1) : aoConcluir(); }, 800);
    } else {
      registrarErro();
      setUsadas((u) => [...u, letra]);
    }
  };

  return (
    <CartaoJogo>
      <BarraProgresso>Complete a palavra! ({indice + 1}/{palavras.length})</BarraProgresso>
      <ImagemFlash src={p.imagem_url} alt={p.portugues} style={{ width: 150 }} />
      <Traducao>{p.portugues}</Traducao>
      <LetrasAlvo>
        {p.alvo.split('').map((letra, i) => (
          <CaixaLetra key={i} cor={mundo.cor} preenchida={i !== puzzle.pos || preenchida}>
            {i === puzzle.pos ? (preenchida ? letra : '') : letra}
          </CaixaLetra>
        ))}
      </LetrasAlvo>
      <LetrasOpcoes>
        {puzzle.opcoes.map((letra) => (
          <TeclaLetra key={letra} usada={usadas.includes(letra)} onClick={() => escolher(letra)}>{letra}</TeclaLetra>
        ))}
      </LetrasOpcoes>
    </CartaoJogo>
  );
}

/* 4) Quiz do mascote (ouve e escolhe a figura) */
function Quiz({ mundo, palavras, registrarErro, aoConcluir }) {
  const [perguntas, setPerguntas] = useState([]);
  const [indice, setIndice] = useState(0);
  const [erradas, setErradas] = useState([]);
  const [opcoes, setOpcoes] = useState([]);
  useEffect(() => { setPerguntas(embaralhar(palavras)); /* eslint-disable-next-line */ }, []);
  const pergunta = perguntas[indice];

  useEffect(() => {
    if (!pergunta) return undefined;
    const distratoras = embaralhar(palavras.filter((p) => p.ingles !== pergunta.ingles)).slice(0, 2);
    setOpcoes(embaralhar([pergunta, ...distratoras]));
    // 1ª pergunta espera a voz-guia terminar (evita duas vozes ao mesmo tempo)
    const t = setTimeout(() => tocarAudio(pergunta.audio_url), indice === 0 ? 1800 : 0);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pergunta]);

  if (!pergunta) return null;

  const escolher = (o) => {
    if (o.ingles === pergunta.ingles) {
      // NÃO tocar o áudio aqui: ao avançar, o próximo som toca sozinho (evita
      // dois sons sobrepostos — o da figura recém-acertada + o da próxima).
      setErradas([]);
      if (indice + 1 < perguntas.length) setIndice(indice + 1); else aoConcluir();
    } else if (!erradas.includes(o.ingles)) {
      registrarErro(); setErradas((e) => [...e, o.ingles]);
    }
  };

  return (
    <CartaoJogo>
      <BarraProgresso>Pergunta {indice + 1} de {perguntas.length}</BarraProgresso>
      <PalavraGrande>{pergunta.alvo}</PalavraGrande>
      <BotaoSom cor={mundo.cor} onClick={() => tocarAudio(pergunta.audio_url)}>🔊 Ouvir de novo</BotaoSom>
      <Subtitulo>Toque na figura certa!</Subtitulo>
      <GradeQuiz>
        {opcoes.map((o) => (
          <OpcaoQuiz key={o.ingles} errada={erradas.includes(o.ingles)} onClick={() => escolher(o)}>
            <img src={o.imagem_url} alt={o.portugues} />
          </OpcaoQuiz>
        ))}
      </GradeQuiz>
    </CartaoJogo>
  );
}
